<h1 class="page-title mb-5">الأحداث</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="search-filter-container mb-5" *ngIf="!selectedEvent">
          <div class="row align-items-start gy-3">
            <div class="col-md-12">
              <div class="row align-items-end p-4" style="background-color: #f2f2f2; border-radius: 4px">
                <div class="col-lg-3 col-md-6">
                  <label class="form-label fw-bold">الفئة</label>
                  <select class="form-select custom-input">
                    <option>الكل</option>
                  </select>
                </div>
                <div class="col-lg-3 col-md-6">
                  <label class="form-label fw-bold">من</label>
                  <div class="input-group">
                    <input type="text" class="form-control custom-input" placeholder="" />
                    <span class="input-group-text bg-custom-green text-white"><i
                        class="material-icons">calendar_today</i></span>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <label class="form-label fw-bold">إلى</label>
                  <div class="input-group">
                    <input type="text" class="form-control custom-input" placeholder="" />
                    <span class="input-group-text bg-custom-green text-white"><i
                        class="material-icons">calendar_today</i></span>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 d-flex gap-2">
                  <button class="btn btn-refresh">
                    <i class="material-icons">refresh</i>
                  </button>
                  <button class="btn btn-search flex-grow-1">بحث</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Event Grid (List View) -->
        <div class="row gy-4" *ngIf="!selectedEvent">
          <div class="col-md-6" *ngFor="let event of events">
            <div class="event-card">
              <div class="green-corner"></div>
              <div class="card-content">
                <div class="meta-info mb-3">
                  <div class="d-flex align-items-center justify-content-start mb-2">
                    <i class="material-icons ms-2 green-icon">calendar_today</i>
                    <span>تاريخ البدء: {{ event.dateStart }} -
                      {{ event.dateEnd }}</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-start">
                    <i class="material-icons ms-2 green-icon">location_on</i>

                    <span>{{ event.location }}</span>
                  </div>
                </div>

                <h3 class="event-title">{{ event.title }}</h3>
                <p class="event-desc">{{ event.description }}</p>

                <div class="text-end mt-4">
                  <button class="btn-read-more" (click)="selectEvent(event)">
                    اقرأ المزيد
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Detail View -->
        <div class="event-detail" *ngIf="selectedEvent">
          <div class="row">
            <div class="col-md-12 mb-4 text-start">
            </div>
            <div class="col-lg-4 order-2 order-lg-1 mb-4 mb-lg-0">
              <div class="detail-image-wrapper">
                <div class="green-backdrop-detail"></div>
                <img [src]="selectedEvent.image" class="detail-img"
                  onerror="this.src='assets/images/placeholder.jpg'" />
              </div>
            </div>
            <div class="col-lg-8 order-1 order-lg-2">
              <div class="meta-info mb-4">
                <div class="d-flex align-items-center justify-content-start mb-2">
                  <i class="material-icons ms-2 green-icon">calendar_today</i>

                  <strong>تاريخ البدء: {{ selectedEvent.dateStart }} -
                    {{ selectedEvent.dateEnd }}</strong>
                </div>
                <div class="d-flex align-items-center justify-content-start">
                  <i class="material-icons ms-2 green-icon">location_on</i>
                  <strong>{{ selectedEvent.location }}</strong>
                </div>
              </div>

              <h2 class="detail-title mb-4">{{ selectedEvent.title }}</h2>

              <div class="detail-text">
                {{ selectedEvent.fullDescription }}
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-media></app-fix-media>
      </div>
    </div>
  </div>
</div>